import { userListColumn, userListMobileColumn } from './UserDetailColumn'
import ReactDataTableWithoutPagination from '../../../../../../../components/_shared/Table/ReactDataTableWithoutPagination'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import { useEffect, useState } from 'react'

const GridEventsTableUserList = ({ data }) => {
    const size = useWindowSize()
    const [count, setCount] = useState(0)
    useEffect(() => {
        if (data) {
            setCount(data?.length)
        }
    }, [data])
    if (size?.width < 768) {
        return (
            <>
                <section className="pt-2 mx-auto">
                    <ReactDataTableWithoutPagination
                        data={data}
                        columns={userListColumn}
                        isSmallScreen={true}
                    />
                    <div className="my-4"></div>

                    <ReactDataTableWithoutPagination
                        data={data}
                        columns={userListMobileColumn}
                        isSmallScreen={true}
                    />
                </section>
            </>
        )
    }
    return (
        <section>
            <div className="p-3 customScrollBarDiv">
                <ReactDataTableWithoutPagination
                    data={data}
                    columns={userListColumn}
                />
                <div className="d-flex gap-5 align-items-center p-3 rounded-lg shadow-md newReport mt-2">
                    <div className=" d-flex align-items-center clrText gap-2">
                        <span className="text-lg font-medium text-gray-700">
                            count:
                        </span>
                        <p className="text-lg font-medium text-blue-600 mt-1">
                            {count}
                        </p>
                    </div>
                    <div className="d-flex  align-items-center gap-2 clrText">
                        <span className="text-lg font-medium text-gray-700">
                            Devices of this User:
                        </span>
                        <p className="text-lg font-medium text-blue-600 mt-1">
                            {count}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default GridEventsTableUserList
